<div class="landing-page">
  <!-- Hero Section -->
  <section class="hero-section" :style="heroStyle">
    <div class="hero-content">
      <div class="hero-card">
        <img
          v-if="$clientLogo"
          :src="$clientLogo"
          alt="Logo"
          class="hero-logo"
          :style="{ width: (branding && branding.logo_width) || '100px' }"
        />
        <h1 class="hero-title">{{ welcomeText }}</h1>
        <p class="hero-subtitle">
          {{ subtext }}
        </p>
        <button class="hero-btn" :style="buttonStyle" @click="next_to_register">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <footer class="landing-footer">
    <p class="footer-text">{{ footerText }}</p>
  </footer>
</div>
